var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDepartureStationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_635_3043)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0881 1.6167C16.8993 0.611176 19.1012 0.611175 20.9125 1.6167L31.1245 7.28583C33.0302 8.34378 34.2123 10.352 34.2123 12.5317V23.4683C34.2123 25.648 33.0302 27.6562 31.1245 28.7142L20.9125 34.3833C19.1012 35.3888 16.8993 35.3888 15.0881 34.3833L4.87607 28.7142C2.97036 27.6562 1.78828 25.648 1.78828 23.4683V12.5317C1.78828 10.352 2.97035 8.34378 4.87607 7.28583L15.0881 1.6167Z",
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6982 17.1016V17.9336H13.4677V18.8125H16.5029V21.1797H10.3857V22.0469H16.7958V22.8906H9.29584V20.4062H15.4013V19.6211H9.28412V18.8125H12.3662V17.9336H8.1474V17.1016H17.6982ZM8.61615 15.8477C10.6259 15.7363 12.0439 15.1211 12.2724 14.2305H9.09662V13.375H12.3662V12.4492H13.4677V13.375H16.749V14.2305H13.5556C13.7783 15.1211 15.1962 15.7363 17.2294 15.8477L16.8896 16.6914C15.0615 16.5566 13.5732 16.0234 12.9169 15.1035C12.2607 16.0234 10.7724 16.5566 8.93256 16.6914L8.61615 15.8477ZM19.7668 12.9414V14.3711H22.5207V12.9414H23.6222V17.5234H18.6769V12.9414H19.7668ZM19.7316 19.2344V18.3555H26.5168V21.0039H20.8449V22H26.8801V22.8906H19.7551V20.1836H25.4152V19.2344H19.7316ZM19.7668 16.6328H22.5207V15.2266H19.7668V16.6328ZM25.4035 17.8984V12.4961H26.5168V14.6992H28.0402V15.6016H26.5168V17.8984H25.4035Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_635_3043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDepartureStationIcon);
export default __webpack_public_path__ + "static/media/ic_departure_station_icon.c8b386aa4c379eaa1248e83692540fba.svg";
export { ForwardRef as ReactComponent };